/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var React = require('react');
var Router = require('react-router');
var $__0=    require('../../../../'),Seq=$__0.Seq;
var Markdown = require('./MarkDown');

var DocOverview = React.createClass({displayName: "DocOverview",
  render:function() {
    var def = this.props.def;
    var doc = def.doc;

    return (
      React.createElement("div", null, 
        doc && (
          React.createElement("section", null, 
            React.createElement(Markdown, {contents: doc.synopsis}), 
            doc.description && React.createElement(Markdown, {contents: doc.description})
          )
        ), 

        React.createElement("h4", {className: "groupTitle"}, "API"), 

        Seq(def.module)
          .map(function(t, name)  {
            var isFunction = !t.interface && !t.module;
            if (isFunction) {
              t = t.call;
            }
            return (
              React.createElement("section", {key: name, className: "interfaceMember"}, 
                React.createElement("h3", {className: "memberLabel"}, 
                  React.createElement(Router.Link, {to: '/' + name}, 
                    name + (isFunction ? '()' : '')
                  )
                ), 
                t.doc && (
                  React.createElement(Markdown, {className: "detail", contents: t.doc.synopsis})
                )
              )
            );
          })
          .valueSeq()
          .toArray()
      )
    );
  },
});

module.exports = DocOverview;
